<template>
    <div
        class="user-block"
        :class="{
            'selectable': allowSelect && !user.isDisabled,
            'disabled': user.isDisabled,
        }"
        :title="user.name || user.email"
        @click="toggleSelect"
    >
        <div class="user-icon">
            <img v-if="user.avatar" :src="user.avatar" />
            <i v-else class="fas fa-user-circle"></i>
        </div>

        <div class="delete-btn-wrapper" v-if="!user.isDisabled">
            <div v-if="allowRemove" @click="removeUser">
                <i
                    class="fas fa-times-circle is-size-5 has-text-danger"
                ></i>
            </div>
            <i
                v-if="isSuccess"
                class="fas fa-check-circle is-size-5"
                :class="[`has-text-${user.isSelected ? 'info' : 'success'}`]"
            ></i>
        </div>

        <div class="delete-btn-wrapper" v-if="user.isOwner">
            <i
                class="fas fa-user-circle is-size-5 has-text-info"
                :title="trans.base_owner"
            ></i>
        </div>

        <div class="user-data-wrapper">
            <div class="user-name">{{ user.name || user.email }}</div>
            <div class="user-email">{{ user.email }}</div>
        </div>

    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
    import userListMixin from "../../../mixins/userListMixin";

    export default {
        mixins: [userListMixin],
        props: {
            user: {
                avatar: String || null,
                name: String || null,
                email: String,
                isSelected: {
                    type: Boolean,
                    default: false,
                },
                isDisabled: {
                    type: Boolean,
                    default: false,
                },
                isOwner: {
                    type: Boolean,
                    default: false,
                }
            },
        },
        methods: {
            ...mapActions('userManagement', {
                removeUserFromStore: 'detachUser',
                selectUserAtStore: 'selectUser',
                deselectUserAtStore: 'deselectUser',
            }),

            /**
             * Переключение отметки `выбран`/`не выбран`
             */
            toggleSelect() {
                if (!this.allowSelect || this.user.isDisabled) return;

                if (this.user.isSelected) {
                    this.deselectUserAtStore(this.userParameters);
                } else {
                    this.selectUserAtStore(this.userParameters);
                }
            },

            /**
             * Удаление пользователя
             */
            removeUser() {
                if (this.allowRemove) {
                    this.removeUserFromStore(this.userParameters);
                }
            },
        },
        computed: {
            ...mapGetters('userManagement', [
                'trans',
            ]),
            userParameters() {
                return {list: this.vuexState, id: this.user.email};
            },
            isSuccess() {
                return (!this.allowRemove && !this.allowSelect)
                    || (this.allowSelect && this.user.isSelected);
            }
        }
    };
</script>

<style lang="scss" scoped>
    .user-name {
        font-weight: bold;
        font-size: 0.92rem;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .user-email {
        color: gray;
        font-size: 0.87rem;
    }

    .user-block {
        border-radius: 3px;
        min-width: 150px;
        margin-right: 2%;
        margin-bottom: 1rem;
        border: 1px solid silver;

        &.selectable {
            cursor: pointer;
            &:hover {
                $box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1),
                    0 0 0 1px rgba(10, 10, 10, 0.1),
                    0 0 20px -10px rgba(0,0,0,0.45);

                -webkit-box-shadow: $box-shadow;
                -moz-box-shadow: $box-shadow;
                box-shadow: $box-shadow;
            }
        }

        &.disabled {
            opacity: .5;
            cursor: not-allowed;
        }

        .user-icon {
            border-radius: inherit;
            overflow: hidden;
            height: 50px;
            width: 50px;
            float: left;
            text-align: center;
        }

        .user-icon i {
            font-size: 40px;
            color: #aaa9a9;
            padding: 5px;
        }

        .user-data-wrapper {
            overflow: hidden;
            padding-left: 7px;
            height: 50px;

            div {
                margin: 0;
                padding: 0;
                width: 100%;
                height: 20px;

                &:first-child {
                    margin-top: 3px;
                }
            }
        }

        .delete-btn-wrapper {
            border-radius: inherit;
            width: 40px;
            height: 50px;
            float: right;

            display: flex;
            justify-content: center;
            align-items: center;

            .fa-times-circle {
                cursor: pointer;
            }
        }

        img {
            height: 100%;
            width: auto;
            max-width: none;
            border-radius: 50%;
            padding: 5px;
        }
    }
</style>
